// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-M":"M_outdoor-recreation-M__9oyHX"};